// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__2+NGA","contact":"footer_contact__xh5hW","backToTopBtn":"footer_backToTopBtn__uUXC5"};